import React from 'react';
import { isFunction } from 'lodash';
import { formatDate } from 'utils';
import { Paragraph, Tooltip } from 'components';
import { DataFormatter } from 'constants/global';

type DateWithTooltipProps = {
  date: string | Date;
  tipId?: string;
  formatter?: string;
  className?: string;
  tooltipProps?: Record<string, any>;
  customFormat?: () => React.ReactNode;
};

export const DateWithTooltip = ({
  date,
  formatter,
  tooltipProps,
  className = '',
  customFormat,
  tipId = 'relativeTimestamp',
}: DateWithTooltipProps) => {
  return (
    <>
      <Tooltip
        place='top'
        delayShow={500}
        {...(tooltipProps || {})}
        id={tipId}
      />
      <Paragraph
        data-for={tipId}
        data-tip={formatDate(date, DataFormatter.full)}
        className={className}
      >
        {isFunction(customFormat)
          ? customFormat()
          : formatDate(date, formatter)}
      </Paragraph>
    </>
  );
};
